<template>
  <gl-table-two-columns :rows="prepareData()" title="Inputs and outputs" />
</template>

<script>
import GlTableTwoColumns from '../../shared/GlTableTwoColumns/index'

export default {
  name: 'TransactionIO',
  components: { GlTableTwoColumns },
  props: {
    tx: {
      type: Object,
      required: true,
    },
  },
  methods: {
    prepareData() {
      const fees =
        this.tx?.minting?.corpFee || this.tx.inputsValue - this.tx.outputsValue || undefined
      return [
        {
          title: 'Total Input',
          value: this.tx.inputsValue / 100000000 + ' PLC',
        },
        {
          title: 'Total Output',
          value: this.tx.outputsValue / 100000000 + ' PLC',
        },
        {
          title: 'Fees',
          value: fees > 0 ? fees / 100000000 + ' PLC' : undefined,
        },
        {
          title: 'Included Own Fee',
          value:
            this.tx?.minting?.userFee === undefined
              ? undefined
              : this.tx?.minting?.userFee / 100000000 + ' PLC',
        },
        {
          title: 'Minted Amount',
          value:
            this.tx?.minting?.frozenAmount === undefined
              ? undefined
              : this.tx?.minting?.frozenAmount / 100000000 + ' PLC',
        },
        {
          active: true,
          title: 'New Born Amount',
          value:
            this.tx?.minting?.mintedAmount === undefined
              ? undefined
              : this.tx?.minting?.mintedAmount / 100000000 + ' PLC',
        },
      ]
    },
  },
}
</script>
